import React from 'react'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import { getLayout } from '../src/layouts/MainLayout'
import { ConsumerPage } from '../src/model'
import { AccountPanel } from '../src/component/AccountPanel'
import { useTranslation } from 'next-i18next'
import { Head } from '../src/component'
import { TrackPageViewed } from '../src/integrations/amplitude'
import { getTheme } from '../src/utils/server/convergence'

const I18N_NAMESPACE = ['common', 'index', 'account', 'terminalError', 'ach', 'cardScan', 'loyalty', 'signUp']

const AccountsPage: ConsumerPage = () => {
  const { t } = useTranslation(I18N_NAMESPACE)

  const pageTitle = `${t('account:title')} | ${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <AccountPanel />
      <TrackPageViewed />
    </>
  )
}

AccountsPage.getLayout = getLayout()

export const getServerSideProps: GetServerSideProps = async (context) => {
  console.log('[account getServerSideProps] ENTRY - Function started')

  const themeResult = await getTheme(context)
  console.log('[account getServerSideProps] Got theme result:', themeResult)

  const translations = await serverSideTranslations(context.locale as string, I18N_NAMESPACE)
  console.log('[account getServerSideProps] Got translations')

  const props = {
    theme: themeResult.theme,
    ...translations,
  }
  console.log('[account getServerSideProps] Returning props:', props)
  return { props }
}

export default AccountsPage
